export default function UnreadBadge() {
  return (
    <span className="rounded-sm border border-status-warning-border bg-status-warning px-2 py-0.5 text-xs font-medium text-status-warning-foreground">
      Unread
    </span>
  );
}
